import "@/features/sidebar/ui/styles/style.scss"
import clsx from "clsx"
import { useGlobal } from "@/app/store/global.ts"
import { SidebarHeader } from "@/features/sidebar/ui/sidebar-header.tsx"
import SidebarMain from "./sidebar-main.tsx"

interface IProps {
  isOpened: boolean
  isMobile: boolean
}

export const Sidebar = ({ isOpened, isMobile }: IProps) => {
  const navOpen = useGlobal(state => state.sidebarIsOpened)

  return (
    <div className={clsx("sidebar", `sidebar__${isMobile ? (navOpen ? "opened__mobile" : "closed__mobile") : isOpened ? "opened" : "closed"}`)}>
      <SidebarHeader />
      <SidebarMain allOpen={!isOpened ? true : void 0} />
    </div>
  )
}
